import {DndProvider, useDrag, useDrop} from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import React, {useEffect, useRef, useState} from "react";
import {FirstAidKitMoveItemProps} from "./FirstAidKitPlay";


interface MoveDragObject {
    id: number
    sourceId: string
    isCorrect: boolean
    explanation: string
}

const MoveDragObjectType = 'move-drag-item'

const MoveItem = ( { id, sourceId, src, name, explanation, isCorrect, isDroppedCorrectly, isHidden } ) => {
    const ref = useRef(null);

    const [, connectDrag] = useDrag({
        item: { id: id, sourceId: sourceId, isCorrect: isCorrect, explanation: explanation },
        type: MoveDragObjectType,
        canDrag: isDroppedCorrectly === undefined,
    })

    connectDrag(ref)

    return <div ref={ref} className={"item" + (isHidden ? " hidden" : "")}>
        <img src={src} />
        <p>{name}</p>
    </div>
}

const DropItem = ( { onDrop } ) => {
    const ref = useRef(null);

    const [, connectDrop] = useDrop({
        accept: MoveDragObjectType,
        drop(dragObject) {
            onDrop(dragObject as MoveDragObject)
        },
    })

    connectDrop(ref)

    return <img ref={ref} src="images/first-aid-kit/aid.png" alt="first aid kit" />
}


export default function FirstAidKitItemMove(props: FirstAidKitMoveItemProps) {

    const processItem = (item: MoveDragObject) => {
        props.onItemDropped(item.id, item.sourceId, item.isCorrect, item.explanation)
    }

    const isItemHidden = (id: string) => {
        return props.itemsHidden !== undefined && props.itemsHidden.indexOf(id) !== -1
    }

    const isDroppedCorrectly = (index: number) => {
        if (props.droppedCorrectly.indexOf(index) !== -1) {
            return true
        } else if (props.droppedIncorrectly.indexOf(index) !== -1) {
            return false
        }
    }

    return <DndProvider backend={HTML5Backend}>

        <div className={"drag-container"}>
            <DropItem onDrop={(item) => processItem(item) } />
            <div className={"counter"}>
                <span>{props.itemsCounting}</span>
            </div>
            <div className={"items" + (props.isFinished ? " hidden" : "")}>
                {props.items.map((item, index) =>
                    <MoveItem id={index} key={index} sourceId={item.id} src={item.photo} name={item.name}
                              explanation={item.description} isCorrect={item.isCorrect} isHidden={isItemHidden(item.id)}
                              isDroppedCorrectly={isDroppedCorrectly(index)}/>
                )}
            </div>
        </div>
    </DndProvider>
}